
import { Avatar, Badge, StatusBadge } from '@/shared/ui';
import type { PaletteItem } from '../model/types';
import { Highlight } from './PaletteRow';
import styles from './CommandPalette.module.css';

const KIND_LABEL: Record<PaletteItem['kind'], string> = {
  ticket: 'Заявка',
  task: 'Задача',
  wiki: 'Инструкция',
  person: 'Человек',
  command: 'Команда',
  more: 'Поиск',
};

export function PalettePreview({ item, mod }: { item: PaletteItem | undefined; mod: string }) {
  if (!item) return <aside className={styles.preview} aria-hidden />;
  const Icon = item.icon;
  const navigable = Boolean(item.to);

  return (
    <aside className={styles.preview} aria-label="Подробнее о выбранном">
      <div className={styles.previewHead}>
        <span className={styles.previewIcon}>
          {item.person ? (
            <Avatar name={item.label} seed={item.person.seed} className={styles.previewAvatar} />
          ) : (
            <Icon size={20} aria-hidden />
          )}
        </span>
        <span className={styles.previewKind}>
          {KIND_LABEL[item.kind]}
          {item.badge && <span className={styles.optionKey}>{item.badge}</span>}
        </span>
      </div>

      <div className={styles.previewTitle}>
        <Highlight text={item.label} ranges={item.ranges} />
      </div>

      {item.status &&
        (item.status.ticketStatus ? (
          <StatusBadge status={item.status.ticketStatus} label={item.status.label} dot />
        ) : (
          <Badge>{item.status.label}</Badge>
        ))}

      {item.description && <p className={styles.previewText}>{item.description}</p>}

      {item.snippet?.length ? (
        <p className={styles.previewText}>
          {item.snippet.map((p, i) =>
            p.mark ? (
              <mark key={i} className={styles.snippetMark}>
                {p.text}
              </mark>
            ) : (
              <span key={i}>{p.text}</span>
            ),
          )}
        </p>
      ) : null}

      {item.details?.length ? (
        <dl className={styles.previewDetails}>
          {item.details
            .filter((d) => d.label !== 'Статус' || !item.status)
            .map((d) => (
              <div key={d.label} className={styles.previewRow}>
                <dt>{d.label}</dt>
                <dd>{d.value}</dd>
              </div>
            ))}
        </dl>
      ) : null}

      <div className={styles.previewKeys}>
        <span>
          <kbd className={styles.kbd}>Enter</kbd> {item.run && !item.to ? 'выполнить' : 'открыть'}
        </span>
        {navigable && (
          <>
            <span>
              <kbd className={styles.kbd}>{mod}Enter</kbd> в новой вкладке
            </span>
            <span>
              <kbd className={styles.kbd}>⇧Enter</kbd> скопировать ссылку
            </span>
          </>
        )}
        {item.removable && (
          <span>
            <kbd className={styles.kbd}>Del</kbd> убрать из недавнего
          </span>
        )}
      </div>
    </aside>
  );
}
